import { selectIsLoggedIn } from '@/features/oAuth/oAuthSlice';
import { useGetUserQuery } from '@/features/user/userApi';
import { UserData } from '@/types/user';
import { DueDiligenceStatus } from '@cex/shared-modules';
import { useSelector } from 'react-redux';
import { extractUserData } from '../helpers/user';

export function useUser(): UserData | undefined {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const { data: userData } = useGetUserQuery(undefined, {
    skip: !isLoggedIn
  });
  const user = extractUserData(userData);

  return user;
}

export const userCanWithdraw = (user: UserData) => {
  return user.permissions.includes('can_withdraw');
};

export const userCanTrade = (user: UserData) => {
  return user.permissions.includes('can_trade');
};

export const userIsBlocked = (user: UserData) => {
  return user.blocked;
};

export const userIsDueDiligenceClean = (user: UserData) => {
  const { dueDiligenceStatus } = user;

  const isDueDiligenceClean = dueDiligenceStatus !== DueDiligenceStatus.RED;
  return isDueDiligenceClean;
};

export const userIsAllowedToTrade = (user: UserData) => {
  const { dueDiligenceStatus, completedKyc } = user;

  const isDueDiligenceClean = dueDiligenceStatus !== DueDiligenceStatus.RED;

  return isDueDiligenceClean && completedKyc && userCanTrade(user) && !userIsBlocked(user);
};

export const userCompletedKyc = (user: UserData) => {
  const { completedKyc } = user;

  return completedKyc && !userIsBlocked(user);
};
